export default "/images/slider-2.jpg?d9d7cb363ee06b566b2a68ae817d0051";